<template>
    <Fling title="飞花令">
        <div class="entry-list pure-g">
            <div
                v-for="item in entries"
                :key="item.name"
                class="pure-u-md-1-8 pure-u-sm-1-8 pure-u-lg-1-12 pure-u-xl-1-12 pure-u-1-5"
            >
                <div class="entry" @click="route(item.uri)">
                    <div class="entry-name">{{ item.title }}</div>
                </div>
            </div>
        </div>
        <div class="about-me" @click="route('about')">
            About飞花令
            <font-awesome-icon icon="arrow-circle-right" />
        </div>
    </Fling>
</template>

<style lang="less" scoped>
@nodemodule: "../../../node_modules/";

@import "@{nodemodule}/purecss/build/grids.css";
@import "@{nodemodule}/purecss/build/grids-responsive.css";

@inactive-color: lighten(black, 70%);
.entry-list {
    padding: 8px;

    @entry-len: 55px;
    .entry {
        box-sizing: border-box;
        margin: 8px;
        height: @entry-len;
        min-width: @entry-len;
        border: 1px solid @inactive-color;
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;

        &:active {
            background-color: black;
            color: white;
        }
    }
}
.about-me {
    font-size: 0.8em;
    position: fixed;
    right: 16px;
    bottom: 16px;
    padding: 3px 8px;
    border: 1px solid @inactive-color;
    border-radius: 8px;
    color: black;
}
</style>

<script>
import "./registerserviceworker";
import Fling from "../components/Frame";
import { url_for } from "../lib/util";

export default {
    components: {
        Fling,
    },
    data() {
        return {
            entries: [
                {
                    name: "poetry",
                    title: "诗词",
                    uri: "poetry",
                },
                {
                    name: "stave",
                    title: "Stave",
                    uri: "stave",
                },
                {
                    name: "stavet",
                    title: "StaveT",
                    uri: "stavet",
                },
                {
                    name: "u",
                    title: "U",
                    uri: "u",
                },
                {
                    name: "gol",
                    title: "Gol",
                    uri: "gol",
                },
            ],
        };
    },
    methods: {
        route(uri) {
            location.href = url_for(uri);
            // this.$router.push(uri)
        },
    },
};
</script>
